import { updateCart as updateCartApi } from "@iewc/Services/CartService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, UpdateCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";

replaceInChain(chain, UpdateCart, async props => {
    const state = props.getState();
    const isGuest = state.context.session?.isGuest;

    const updatedCart = { ...props.cart };

    if (isGuest) {
        //  We dont need for guest on this page, since its causing issues with the shippingOptions custom prop value
        updatedCart.properties = {};
    }

    props.apiParameter.cart = { ...updatedCart };

    props.apiParameter.additionalQueryStringParameters = {
        ...props.apiParameter.additionalQueryStringParameters,
        ignoreProperties: true,
    };

    props.apiResult = await updateCartApi(props.apiParameter);
});
